module.exports = __webpack_public_path__ + "media/images/news/yw_title-a8e3b08f25eb5c8448a5eed3381d2887.png";